import * as React from "react";
import { Box, Table, TableBody, TableCell, TableSortLabel, TableContainer, TableHead, TablePagination, TableRow, Divider, Checkbox, Button, IconButton, TextField, Tooltip, } from "@material-ui/core";
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage, } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { TableRowsSkeleton } from "frontend/src/ui/table-skeleton";
import { Tracks } from "./tracks";
import { Skeleton } from "@material-ui/lab";
var headCells = [
    { id: "title", label: "Название", isSortable: true },
    { id: "artist", label: "Исполнитель", isSortable: true },
    { id: "genres", label: "Жанры", isSortable: true },
    { id: "duration", label: "Время", isSortable: true },
    { id: "created_at", label: "Дата", isSortable: true },
    { id: "ISRC", label: "ISRC", isSortable: true },
    { id: "is_normalized", label: "Норм.", isSortable: true },
    { id: "is_approved", label: "Одобрен?", isSortable: true },
];
var usePaginationActionsStyles = makeStyles({
    root: {
        alignItems: "center",
        display: "flex",
        flexShrink: 0,
        flexWrap: "nowrap",
        gap: 4,
        justifyContent: "flex-end",
        padding: 4,
        whiteSpace: "nowrap",
    },
    pageInput: {
        width: 72,
    },
});
var clampPage = function (page, lastPage) {
    return Math.max(0, Math.min(page, lastPage));
};
var TracksPaginationActions = function (_a) {
    var count = _a.count, page = _a.page, rowsPerPage = _a.rowsPerPage, onPageChange = _a.onPageChange;
    var classes = usePaginationActionsStyles();
    var lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
    var _b = React.useState(String(page + 1)), pageInput = _b[0], setPageInput = _b[1];
    React.useEffect(function () {
        setPageInput(String(page + 1));
    }, [page]);
    var goToPage = function (nextPage) {
        onPageChange(null, clampPage(nextPage, lastPage));
    };
    var submitPageInput = function () {
        var nextPage = Number(pageInput);
        if (!Number.isFinite(nextPage)) {
            setPageInput(String(page + 1));
            return;
        }
        goToPage(nextPage - 1);
    };
    return (React.createElement(Box, { className: classes.root },
        React.createElement(Tooltip, { title: "\u0412 \u043D\u0430\u0447\u0430\u043B\u043E" },
            React.createElement("span", null,
                React.createElement(IconButton, { size: "small", disabled: page === 0, onClick: function () { return goToPage(0); } },
                    React.createElement(FirstPage, null)))),
        React.createElement(Button, { size: "small", disabled: page === 0, onClick: function () { return goToPage(page - 100); } }, "-100"),
        React.createElement(Button, { size: "small", disabled: page === 0, onClick: function () { return goToPage(page - 10); } }, "-10"),
        React.createElement(Tooltip, { title: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430" },
            React.createElement("span", null,
                React.createElement(IconButton, { size: "small", disabled: page === 0, onClick: function () { return goToPage(page - 1); } },
                    React.createElement(KeyboardArrowLeft, null)))),
        React.createElement(TextField, { className: classes.pageInput, label: "\u0421\u0442\u0440.", margin: "dense", size: "small", type: "number", value: pageInput, variant: "outlined", inputProps: { min: 1, max: lastPage + 1 }, onBlur: submitPageInput, onChange: function (event) { return setPageInput(event.target.value); }, onKeyDown: function (event) {
                if (event.key === "Enter") {
                    submitPageInput();
                }
            } }),
        React.createElement(Tooltip, { title: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430" },
            React.createElement("span", null,
                React.createElement(IconButton, { size: "small", disabled: page >= lastPage, onClick: function () { return goToPage(page + 1); } },
                    React.createElement(KeyboardArrowRight, null)))),
        React.createElement(Button, { size: "small", disabled: page >= lastPage, onClick: function () { return goToPage(page + 10); } }, "+10"),
        React.createElement(Button, { size: "small", disabled: page >= lastPage, onClick: function () { return goToPage(page + 100); } }, "+100"),
        React.createElement(Tooltip, { title: "\u0412 \u043A\u043E\u043D\u0435\u0446" },
            React.createElement("span", null,
                React.createElement(IconButton, { size: "small", disabled: page >= lastPage, onClick: function () { return goToPage(lastPage); } },
                    React.createElement(LastPage, null))))));
};
export var TracksSearchResultTable = React.memo(function (_a) {
    var sorting = _a.sorting, pagination = _a.pagination, tracks = _a.tracks, showIsrc = _a.showIsrc;
    var visibleHeadCells = headCells.filter(function (headCell) { return showIsrc || headCell.id !== "ISRC"; });
    var node = (React.createElement(TablePagination, { component: "div", count: tracks.total, page: pagination.page, onPageChange: pagination.onChangePage, rowsPerPage: pagination.rowsPerPage, onRowsPerPageChange: pagination.onChangeRowsPerPage, labelRowsPerPage: "Показывать треков", ActionsComponent: TracksPaginationActions }));
    return (React.createElement(Box, null,
        tracks.entries ? (node) : (React.createElement(Box, { display: "flex", justifyContent: "flex-end" },
            React.createElement(Skeleton, null, node))),
        React.createElement(Divider, null),
        React.createElement(TableContainer, null,
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null,
                            React.createElement(Checkbox, { checked: tracks.checked.visible.all, indeterminate: tracks.checked.visible.some, onChange: tracks.checked.visible.toggle, color: "primary", inputProps: {
                                    "aria-label": "Выделить все треки на странице",
                                } })),
                        visibleHeadCells.map(function (headCell) { return (React.createElement(TableCell, { key: headCell.id, sortDirection: sorting.sortBy === headCell.id ? sorting.orderBy : false }, headCell.isSortable ? (React.createElement(TableSortLabel, { active: sorting.sortBy === headCell.id, direction: sorting.sortBy === headCell.id
                                ? sorting.orderBy
                                : "asc", onClick: function () { return sorting.onChange(headCell.id); } }, headCell.label)) : (headCell.label))); }),
                        React.createElement(TableCell, null))),
                React.createElement(TableBody, null, tracks.entries ? (React.createElement(Tracks, { tracks: tracks.entries, onTrackToggle: tracks.onToggle, onPause: tracks.onPause, onPlay: tracks.onPlay, onResume: tracks.onResume, showIsrc: showIsrc })) : (React.createElement(TableRowsSkeleton, { rows: pagination.rowsPerPage, columns: showIsrc ? 9 : 8 }))))),
        React.createElement(Divider, null),
        tracks.entries ? (node) : (React.createElement(Box, { display: "flex", justifyContent: "flex-end" },
            React.createElement(Skeleton, null, node)))));
});
